module.exports = __webpack_public_path__ + "img/welding1.3ec17c6a.png";